import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DeliveryFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.875 13.7324C15.3328 13.836 14.0809 14.9991 13.8411 16.5H8.84735C8.59593 14.9269 7.23276 13.7249 5.58884 13.7249C4.28763 13.7249 3.16232 14.4779 2.625 15.5721C2.48348 15.8602 2.38274 16.172 2.33033 16.5H1.125V6H16.875V12.375H18.375V8.25H20.9464L22.875 12V16.5H20.3581C20.1758 15.3596 19.4092 14.4141 18.375 13.9804C17.9826 13.8158 17.5517 13.7249 17.0996 13.7249C17.0241 13.7249 16.9492 13.7274 16.875 13.7324ZM7.16371 17.0247C7.16371 17.8946 6.45855 18.5997 5.58869 18.5997C4.71883 18.5997 4.01367 17.8946 4.01367 17.0247C4.01367 16.1549 4.71883 15.4497 5.58869 15.4497C6.45855 15.4497 7.16371 16.1549 7.16371 17.0247ZM18.6745 17.0247C18.6745 17.8946 17.9693 18.5997 17.0994 18.5997C16.2296 18.5997 15.5244 17.8946 15.5244 17.0247C15.5244 16.1549 16.2296 15.4497 17.0994 15.4497C17.9693 15.4497 18.6745 16.1549 18.6745 17.0247Z"
      />
    </SvgIcon>
  );
});
